import * as api from '../apis/information';
import { apiCall } from '~/lib/redux/api';
import { InformationActions } from "~/apps/shared/actions/consts";

export function getInformationSettings() {
  return apiCall({
    actions: [
      InformationActions.LOAD_REQUEST,
      InformationActions.LOAD_SUCCESS,
      InformationActions.LOAD_ERROR,
    ],
    normalizer: null,
    fn: () => api.getInformationSettings(),
  })
}
